let baseURL;
let siteURL;
let domain;
let imgURL;

switch (process.env.NODE_ENV) {
  case "development":
    baseURL = "http://192.168.0.183:8080/api";
    siteURL = "https://server.aoying.kuchuangnet.com/";
    domain = "https://aoying.kuchuangnet.com";
    imgURL = "https://oss.bee.kuchuangnet.com";
    break;
  case "production":
    /*蜂航物流*/
    /*baseURL = 'https://h5.aoying.kuchuangnet.com/stage-api';
        siteURL = 'https://h5.aoying.kuchuangnet.com';
        domain = 'https://aoying.kuchuangnet.com';*/

    /*运立方*/
    baseURL = "/prod-api";
    siteURL = "https://yunlifang.kuchuangnet.com";
    domain = "https://yunlifang.kuchuangnet.com";

    imgURL = "https://oss.bee.kuchuangnet.com";
    break;
}

export default {
  baseURL,
  siteURL,
  domain,
  imgURL,
};
